import { Container } from 'inversify'

import Sentry from '@collector/shared-plugin-sentry-vue'
import * as sportsAPI from '@mobile/globalState/sportsAPI'

import { SoccerRelationIoCBindings } from './SoccerRelationDependencies'

export function bindExpectedGoalsZonesMatrix(ioc: Container): void {
  ioc
    .bind(SoccerRelationIoCBindings.ExpectedGoalsZonesMatrix)
    .toDynamicValue(async () => {
      try {
        const response =
          await sportsAPI.state.client.getIncidentsExpectedGoalsZonesMatrix()

        return response.api.data
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch expected goals zones matrix.', error)
        Sentry.captureException(error)
      }

      return []
    })
    .inSingletonScope()
}
